import TruckInMotionOutlineIcon from "../../common/icons/TruckInMotionOutlineIcon";

export default {
  icon: TruckInMotionOutlineIcon,
};
